var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.25a.752.752 0 00-.75.75v2.25H5a.752.752 0 00-.75.75c0 .413.338.75.75.75h2.25V11c0 .412.338.75.75.75.413 0 .75-.338.75-.75V8.75H11c.413 0 .75-.337.75-.75a.752.752 0 00-.75-.75H8.75V5A.752.752 0 008 4.25zM8 .5C3.86.5.5 3.86.5 8c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5C15.5 3.86 12.14.5 8 .5zM8 14c-3.307 0-6-2.693-6-6s2.693-6 6-6c3.308 0 6 2.693 6 6s-2.692 6-6 6z"
  })));
}
export default SvgAdd;